module.exports = __webpack_public_path__ + "img/offers.weekly.57bf3e16.png";